export function toCamelCase(text: string): string {
  if (!text || typeof text !== "string") {
    return text;
  }

  return text
    .toLowerCase()
    .split(" ")
    .map((word) => {
      if (word.length === 0) return word;
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
}

export function formatToCamelCase(text: string): string {
  if (!text || typeof text !== "string") {
    return text;
  }

  const leadingSpaces = text.match(/^\s*/)?.[0] || "";
  const trimmedText = text.trimStart();

  if (!trimmedText) {
    return text;
  }

  return leadingSpaces + toCamelCase(trimmedText);
}
